import { Outlet } from "@remix-run/react";
import Container from "~/components/container";
export default function main() {
  return (
    <Container>
      <article
        // The markdown comes in via the parser wrapped in `div.md-prose`
        // so we don't need to do that here
        className="prose lg:prose-lg md:mx-4 prose-slate"
      >
        <Outlet />
      </article>
    </Container>
  );
}
